import SettingsCard from "../common/settings-card";
import AllowAnonCalls from "./allow-anon-calls";
import { memo } from "react";

const PhoneSettings = () => {
  return (
    <SettingsCard noSpacing title="Call Types">
      <AllowAnonCalls />
    </SettingsCard>
  );
};

export default memo(PhoneSettings);
